import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HeaderIcons.css';

const HeaderIcons = () => {
  const navigate = useNavigate();
  const [cartItemCount, setCartItemCount] = useState(0);

  // Load cart count on component mount
  useEffect(() => {
    const updateCartCount = () => {
      const savedCartItems = localStorage.getItem('panelaCrumbsCart');
      if (savedCartItems) {
        const items = JSON.parse(savedCartItems);
        const count = items.reduce((sum, item) => sum + item.quantity, 0);
        setCartItemCount(count);
      } else {
        setCartItemCount(0);
      }
    };
    
    updateCartCount();
    
    // Listen for cart updates from other pages/components
    window.addEventListener('cartUpdated', updateCartCount);
    
    return () => {
      window.removeEventListener('cartUpdated', updateCartCount);
    };
  }, []);

  const handleCartClick = () => {
    navigate('/cart');
  };

  return (
    <div className="header-icons">
      <div className="cart-icon-container" onClick={handleCartClick}>
        <svg className="icon cart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
        {cartItemCount > 0 && (
          <span className="cart-badge">{cartItemCount}</span>
        )}
      </div>
      {/* <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg> */}
    </div>
  );
};

export default HeaderIcons; 